// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { blockWithRibbon16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-block-with-ribbon': IconBlockWithRibbon;
    }
}

/**
 * The icon component for the 'blockWithRibbon' icon
 */
export class IconBlockWithRibbon extends Icon {
    public constructor() {
        super(blockWithRibbon16X16);
    }
}

registerIcon('icon-block-with-ribbon', IconBlockWithRibbon);
export const iconBlockWithRibbonTag = 'nimble-icon-block-with-ribbon';
